// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0635aec3","404":"4fa095ab","787":"e6fbcae0"}[chunkId] + ".chunk.js";
};